'use strict';

/**
 * Ajaxの結果でDOM要素を更新する
 *
 * @param {object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 */
function updateDom($results, selector) {
    let $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Ajaxの結果を解析し、選択したDOM要素を更新する
 *
 * @param {string} response - Ajax response HTML code
 * @param {string} refreshArea - 更新部分を指定するクラス名
 * @returns {undefined}
 */
function parseResults(response,refreshArea) {
    const $parsedResponse = $(response);
    const selector = refreshArea;

    updateDom($parsedResponse, selector);
}

module.exports = parseResults;
